// import * as React, from "react";
import React, {useEffect, useState, useRef} from "react";

// React Bootstrap
import {Modal, Tab, Nav, Offcanvas} from 'react-bootstrap';


// Import Slider

// Import Components

// Import Images
import logoblack from '../assets/images/doru-xdc-logo-black.svg'
import xdcBannerImg from '../assets/images/xdc-banner-img.png'
import xdcAboutImg from '../assets/images/xdc-about-img.png'
import xdcChooseMobileImg from '../assets/images/xdc-choose-mobile-img.png'
import xdcChooseCircleImg from '../assets/images/xdc-choose-bg-circle.png'
import purpleFiveStarImg from '../assets/images/purple-five-star.png'
import userImg1 from '../assets/images/xdc-user-img-1.png'
import userImg2 from '../assets/images/xdc-user-img-2.png'
import userImg3 from '../assets/images/xdc-user-img-3.png'
import qrCodeImg from '../assets/images/safe-qr-code.png'

// Import Icons
import menuBarIcon from "../assets/images/icons/hamburger-menu-white.svg";
import xdcFeatureIcon1 from "../assets/images/icons/xdc-feature-icon-1.svg";
import xdcFeatureIcon2 from "../assets/images/icons/xdc-feature-icon-2.svg";
import xdcFeatureIcon3 from "../assets/images/icons/xdc-feature-icon-3.svg";
import xdcFeatureIcon4 from "../assets/images/icons/xdc-feature-icon-4.svg";
import xdcAboutIcon1 from "../assets/images/icons/xdc-about-card-icon-1.svg";
import xdcAboutIcon2 from "../assets/images/icons/xdc-about-card-icon-2.svg";
import xdcChooseIcon1 from "../assets/images/icons/xdc-choose-card-icon-1.svg";
import xdcChooseIcon2 from "../assets/images/icons/xdc-choose-card-icon-2.svg";
import xdcChooseIcon3 from "../assets/images/icons/xdc-choose-card-icon-3.svg";
import xdcChooseIcon4 from "../assets/images/icons/xdc-choose-card-icon-4.svg";
import playstoreWhiteIcon from "../assets/images/icons/playstore-white-icon.svg";
import appletoreWhiteIcon from "../assets/images/icons/apple-store-white-icon.svg";
import chainIcon1 from "../assets/images/icons/chain-list-icon-1.svg";
import chainIcon2 from "../assets/images/icons/chain-list-icon-2.svg";
import chainIcon3 from "../assets/images/icons/chain-list-icon-3.svg";
import chainIcon4 from "../assets/images/icons/chain-list-icon-4.svg";
import chainIcon5 from "../assets/images/icons/chain-list-icon-5.svg";
import barcodeArrowIcon from "../assets/images/icons/barcode-up-white-arrow.svg";
import twitterIcon from "../assets/images/icons/xdc-twitter-icon.svg";
import telegramIcon from "../assets/images/icons/xdc-telegram-icon.svg";
import discrodIcon from "../assets/images/icons/xdc-discord-icon.svg";
import youtubeIcon from "../assets/images/icons/xdc-youtube-icon.svg";
import linkedinICon from "../assets/images/icons/footer-linkedin-icon.svg";
import twitterICon from "../assets/images/icons/footer-twitter-icon.svg";
import fbICon from "../assets/images/icons/footer-fb-icon.svg";


function LandingPage() {
    const [openMenu, setOpenMenu] = useState(false);

    useEffect(() => {
        document.body.classList.add("xdc-landing-page-body");
        // Cleanup: Remove the class when the component unmounts or route changes
        return () => {
            document.body.classList.remove("xdc-landing-page-body");
        };
    });

    const toggleMenu = () => {
        setOpenMenu(prev => !prev);
    };


    return (
        <div className='home-page'>

            <div className={`xdc-header ${openMenu ? 'menu-open' : ''}`}>
                <div className="header-wrapper">
                    <div className="logo-wrapper">
                        <a href="#" className="logo">
                            <img src={logoblack} alt="logo"/>
                        </a>
                    </div>
                    <div className="navbar-menu">
                        <div className="menu-bar">
                            <img src={menuBarIcon} onClick={toggleMenu} alt="icon"/>
                        </div>
                        <ul className={`menu ${openMenu ? 'active' : ''}`}>
                            <li><a href="#">Buy Air-gapped Device </a></li>
                            <li><a href="#">Download App</a></li>
                            <li><a href="#">Broadcast Transaction</a></li>
                            <li><a href="#">Features</a></li>
                            <li><a href="#">Contact Us</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <section className="sec-xdc-banner">
                <div className="container w-1200">
                    <div className="row">
                        <div className="col-lg-7 col-md-12">
                            <div className="content-wrapper">
                                <h1 className="f-inter black-1">The next-gen <br/>
                                    Secure crypto <br/>
                                    Hardware wallet</h1>
                                <h3 className="f-inter f-22 w-400">Store and manage your crypto safely and <br/> easily with our fully air-gapped device.</h3>
                                <ul className="btn-list">
                                    <li><a href="#" className="btn-style xdc-purple">Buy Now</a></li>
                                    <li><a href="#" className="btn-style xdc-purple transparent">Download</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="img-wrapper">
                                <img src={xdcBannerImg} alt="img"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="xdc-landing-main">

                <div className="xdc-border-grid">
                    <span className="xdc-bg-border"></span>
                    <span className="xdc-bg-border"></span>
                    <span className="xdc-bg-border"></span>
                    <span className="xdc-bg-border"></span>
                    <span className="xdc-bg-border"></span>
                    <span className="xdc-bg-border"></span>
                </div>

                <section className="xdc-statistics">
                    <div className="container w-1200">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="statistics-card">
                                    <strong className="f-inter black-1">9.3M+</strong>
                                    <p className="f-inter f-15 gray-2">Wallets Created</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="statistics-card">
                                    <strong className="f-inter black-1">50+ <a href="#" className="btn-tag-01 bg-green f-inter">Counting...</a></strong>
                                    <p className="f-inter f-15 gray-2">Countries Supported</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="statistics-card">
                                    <strong className="f-inter black-1">$100B</strong>
                                    <p className="f-inter gray-2 f-15">Assets on Platform</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="sec-xdc-features">
                    <div className="container w-1200">
                        <div className="xdc-heading">
                            <strong>KEY FEATURES</strong>
                            <h2>Designed to Empower Your Journey</h2>
                            <p>A next-generation hardware wallet built to protect your digital wealth.</p>
                        </div>
                        <div className="feature-grid">
                            <div className="feature-card">
                                <div className="icon">
                                    <img src={xdcFeatureIcon1} alt="icon"/>
                                </div>
                                <div className="content">
                                    <h3 className="f-inter black-1 f-20 w-500">Offline Key Generation <br/> And Storage</h3>
                                    <p className="f-inter gray-2 f-18 w-400">Create 12/24-word seed phrases securely with no network exposure.</p>
                                </div>
                            </div>
                            <div className="feature-card">
                                <div className="icon">
                                    <img src={xdcFeatureIcon2} alt="icon"/>
                                </div>
                                <div className="content">
                                    <h3 className="f-inter black-1 f-20 w-500">QR-Based Transaction <br/> Signing</h3>
                                    <p className="f-inter gray-2 f-18 w-400">Use camera-only interface to scan and approve transactions from online devices.</p>
                                </div>
                            </div>
                            <div className="feature-card">
                                <div className="icon">
                                    <img src={xdcFeatureIcon3} alt="icon"/>
                                </div>
                                <div className="content">
                                    <h3 className="f-inter black-1 f-20 w-500">Seamless Multi-Chain <br/> Support</h3>
                                    <p className="f-inter gray-2 f-18 w-400">Built for XDC (XRC20), BTC, ETH (ERC20), and future support for Solana, BNB, and more.</p>
                                </div>
                            </div>
                            <div className="feature-card">
                                <div className="icon">
                                    <img src={xdcFeatureIcon4} alt="icon"/>
                                </div>
                                <div className="content">
                                    <h3 className="f-inter black-1 f-20 w-500">XDC Network <br/>
                                        Optimized</h3>
                                    <p className="f-inter gray-2 f-18 w-400">Native XDC support with low gas signing, and fast integration into the XDC ecosystem.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="about-bg-main">

                    <section className="sec-xdc-about">
                        <div className="container w-1200">
                            <div className="about-grid">
                                <div className="content-wrapper">
                                    <div className="xdc-heading">
                                        <strong>About Us</strong>
                                        <h2>Turn your Phone into a Cold Wallet. <br/>
                                            No Internet. No Compromise.</h2>
                                        <p>A next-generation hardware wallet built to protect your digital wealth. <br/>
                                            Your private keys never leave the device — ensuring absolute security <br/>
                                            against hacks and malware.</p>
                                    </div>
                                    <div className="about-card-grid">
                                        <div className="about-card">
                                            <div className="icon">
                                                <img src={xdcAboutIcon1} alt="icon"/>
                                            </div>
                                            <div className="content">
                                                <h3 className="f-inter black-1 f-20 w-500">Air-gapped <br/>Security</h3>
                                                <p className="f-inter gray-2 f-18 w-400">Works on devices with no SIM, Wi-Fi, or Bluetooth — 100% isolated from potential threats.</p>
                                            </div>
                                        </div>
                                        <div className="about-card">
                                            <div className="icon">
                                                <img src={xdcAboutIcon2} alt="icon"/>
                                            </div>
                                            <div className="content">
                                                <h3 className="f-inter black-1 f-20 w-500">Tamper Resistant <br/> Hardware</h3>
                                                <p className="f-inter gray-2 f-18 w-400">Securely store private keys to prevent tampering.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="img-wrapper">
                                    <img src={xdcAboutImg} alt="img"/>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="sec-choose-xdc">
                        <img src={xdcChooseCircleImg} alt="img" className="bg-circle"/>
                        <div className="container w-1200">
                            <div className="xdc-heading">
                                <strong>Why Choose DORU Wallet</strong>
                                <h2>Air-Gapped Mobile App – Secure <br/>
                                    Offline Signing for Web3</h2>
                                <p>Lorem ipsum sit dollar amet, feugiat  nulla suspendise torte aene in amet morbi.</p>
                            </div>
                            <div className="choose-grid">
                                <div className="choose-column">
                                    <div className="choose-card">
                                        <div className="icon">
                                            <img src={xdcChooseIcon1} alt="icon"/>
                                        </div>
                                        <div className="content">
                                            <h3 className="f-inter black-1 f-20 w-500">Send And Receive</h3>
                                            <p className="f-inter gray-2 f-17 w-400">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat nulla suspendisse tortor aene.</p>
                                        </div>
                                    </div>
                                    <div className="choose-card">
                                        <div className="icon">
                                            <img src={xdcChooseIcon2} alt="icon"/>
                                        </div>
                                        <div className="content">
                                            <h3 className="f-inter black-1 f-20 w-500">100% Secure Wallet</h3>
                                            <p className="f-inter gray-2 f-17 w-400">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat nulla suspendisse tortor aene.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="choose-column">
                                    <div className="mobile-card">
                                        <div className="content">
                                            <h3 className="f-inter f-20 w-500">iOS and Android App</h3>
                                            <p className="f-inter f-17 w-400">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat nulla suspendisse tortor aene.</p>
                                        </div>
                                        <div className="mobile-img">
                                            <img src={xdcChooseMobileImg} alt="img"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="choose-column">
                                    <div className="choose-card">
                                        <div className="icon">
                                            <img src={xdcChooseIcon3} alt="icon"/>
                                        </div>
                                        <div className="content">
                                            <h3 className="f-inter black-1 f-20 w-500">Offline Transaction Signing</h3>
                                            <p className="f-inter gray-2 f-17 w-400">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat nulla suspendisse tortor aene.</p>
                                        </div>
                                    </div>
                                    <div className="choose-card">
                                        <div className="icon">
                                            <img src={xdcChooseIcon4} alt="icon"/>
                                        </div>
                                        <div className="content">
                                            <h3 className="f-inter black-1 f-20 w-500">Wallet Without Internet</h3>
                                            <p className="f-inter gray-2 f-17 w-400">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat nulla suspendisse tortor aene.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ul className="btn-list">
                                <li>
                                    <a href="#" className="btn-style xdc-purple icon">
                                        <img src={playstoreWhiteIcon} alt="icon"/>
                                        Play Store
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="btn-style xdc-purple icon">
                                        <img src={appletoreWhiteIcon} alt="icon"/>
                                        App Store
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </section>

                </div>

                <section className="sec-review">
                    <div className="container w-1200">
                        <div className="xdc-heading">
                            <strong>TESTIMONIALS</strong>
                            <h2>Built for Growth. Trusted by Many.</h2>
                            <p>Hear what they say about us and why you should choose us!</p>
                        </div>
                        <div className="review-grid">
                            <div className="review-card">
                                <div className="star-img">
                                    <img src={purpleFiveStarImg} alt="img"/>
                                </div>
                                <div className="review-content">
                                    <p className="f-inter gray-2 f-17 w-400">“Doru has revolutionized my crypto journey — its intuitive interface and strong security give me full confidence in managing my digital assets.”</p>
                                </div>
                                <div className="user-profile">
                                    <div className="user-img">
                                        <img src={userImg1} alt="img"/>
                                    </div>
                                    <div className="user-content">
                                        <strong className="f-inter black-1 f-16">John Clayton</strong>
                                        <p className="f-inter gray-2 f-15">Entrepreneur</p>
                                    </div>
                                </div>
                            </div>
                            <div className="review-card">
                                <div className="star-img">
                                    <img src={purpleFiveStarImg} alt="img"/>
                                </div>
                                <div className="review-content">
                                    <p className="f-inter gray-2 f-17 w-400">“Doru has revolutionized my crypto journey — its intuitive interface and strong security give me full confidence in managing my digital assets.”</p>
                                </div>
                                <div className="user-profile">
                                    <div className="user-img">
                                        <img src={userImg2} alt="img"/>
                                    </div>
                                    <div className="user-content">
                                        <strong className="f-inter black-1 f-16">Savanna Bridgers</strong>
                                        <p className="f-inter gray-2 f-15">Investor</p>
                                    </div>
                                </div>
                            </div>
                            <div className="review-card">
                                <div className="star-img">
                                    <img src={purpleFiveStarImg} alt="img"/>
                                </div>
                                <div className="review-content">
                                    <p className="f-inter gray-2 f-17 w-400">“Doru has revolutionized my crypto journey — its intuitive interface and strong security give me full confidence in managing my digital assets.”</p>
                                </div>
                                <div className="user-profile">
                                    <div className="user-img">
                                        <img src={userImg3} alt="img"/>
                                    </div>
                                    <div className="user-content">
                                        <strong className="f-inter black-1 f-16">Abel Sheldin</strong>
                                        <p className="f-inter gray-2 f-15">Founder</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="sec-xdc-chain">
                    <div className="container w-1200">
                        <div className="xdc-heading">
                            <strong>Multichain Integration</strong>
                            <h2>Compatible with All Major Cryptos</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        </div>
                        <div className="chain-list-card">
                            <ul className="chain-list">
                                <li>
                                    <a href="#" className="chain-icon">
                                        <img src={chainIcon1} alt="icon"/>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="chain-icon">
                                        <img src={chainIcon2} alt="icon"/>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="chain-icon">
                                        <img src={chainIcon3} alt="icon"/>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="chain-icon">
                                        <img src={chainIcon4} alt="icon"/>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" className="chain-icon">
                                        <img src={chainIcon5} alt="icon"/>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="safe-crypto-card">
                            <div className="safe-content">
                                <h2 className="f-inter f-44">Safeguard your Crypto
                                    Assets with Doru</h2>
                                <p className="f-inter f-17 w-400">Securely manage your crypto on the go with our intuitive wallet app. Don’t just store it—protect it with Doru. Get your hardware wallet today.</p>
                                <ul className="btn-list">
                                    <li><a href="#" className="btn-style xdc-purple btn-white">Buy Now</a></li>
                                    <li><a href="#" className="btn-style xdc-purple transparent btn-white">Download</a></li>
                                </ul>
                            </div>
                            <div className="safe-mobile-img">
                                <img src={xdcChooseMobileImg} alt="img"/>
                            </div>
                            <div className="barcode-wrapper">
                                <div className="barcode-icon-main">
                                    <div className="barcode-icon">
                                        <img src={qrCodeImg} alt="img"/>
                                    </div>
                                </div>
                                <div className="arrow-icon">
                                    <img src={barcodeArrowIcon} alt="icon"/>
                                </div>
                                <p className="f-inter f-15 w-400">Scan to download
                                    Doru wallet</p>
                            </div>
                        </div>
                    </div>
                </section>

            </div>

            <div className="xdc-footer">
                <div className="container w-1200">
                    <div className="top-footer">
                        <div className="row">
                            <div className="col-lg-3 col-md-12">
                                <div className="social-wrapper">
                                    <div className="logo-wrapper">
                                        <a href="#" className="logo">
                                            <img src={logoblack} alt="logo"/>
                                        </a>
                                        <p className="f-inter f-15 w-400">Supported by XDC Innovation <br/>
                                            Center | Dubai, UAE</p>
                                    </div>
                                    <div className="social-card">
                                        <ul className="social-list">
                                            <li><a href="#"><img src={twitterICon} alt="icon"/></a></li>
                                            <li><a href="#"><img src={telegramIcon} alt="icon"/></a></li>
                                            <li><a href="#"><img src={discrodIcon} alt="icon"/></a></li>
                                            <li><a href="#"><img src={youtubeIcon} alt="icon"/></a></li>
                                        </ul>
                                        <p className="f-inter f-15 w-400">Copyright © Doru.co 2024. <br/>
                                            All Rights Reserved.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4">
                                <div className="link-wrapper">
                                    <div className="link-card">
                                        <strong>Product</strong>
                                        <ul className="link-list">
                                            <li><a href="#">Features</a></li>
                                            <li><a href="#">Buy an Air-gapped Device</a></li>
                                            <li><a href="#">Download Mobile App</a></li>
                                            <li><a href="#">Broadcast Transaction</a></li>
                                            <li><a href="#">Comparison with Other Wallets</a></li>
                                            <li><a href="#">Add Coins / Network Support</a></li>
                                        </ul>
                                    </div>
                                    <div className="link-card">
                                        <strong>Resources</strong>
                                        <ul className="link-list">
                                            <li><a href="#">Setup Guides</a></li>
                                            <li><a href="#">Security Best Practices</a></li>
                                            <li><a href="#">Developer Tools</a></li>
                                            <li><a href="#">User Manual / Documentation</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4">
                                <div className="link-wrapper">
                                    <div className="link-card">
                                        <strong>Company</strong>
                                        <ul className="link-list">
                                            <li><a href="#">About Doru</a></li>
                                            <li><a href="#">Our Mission</a></li>
                                            <li><a href="#">Security Commitment</a></li>
                                            <li><a href="#">Media & Press</a></li>
                                        </ul>
                                    </div>
                                    <div className="link-card">
                                        <strong>Business</strong>
                                        <ul className="link-list">
                                            <li><a href="#">Affiliate Program</a></li>
                                            <li><a href="#">Partnership Opportunities</a></li>
                                            <li><a href="#">B2B & Bulk Orders</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4">
                                <div className="link-wrapper">
                                    <div className="link-card">
                                        <strong>Support</strong>
                                        <ul className="link-list">
                                            <li><a href="#">Contact Us</a></li>
                                            <li><a href="#">FAQs</a></li>
                                            <li><a href="#">Warranty & Returns</a></li>
                                            <li><a href="#">Shipping & Refund Policy</a></li>
                                        </ul>
                                    </div>
                                    <div className="link-card">
                                        <strong>Legal</strong>
                                        <ul className="link-list">
                                            <li><a href="#">Terms of Service</a></li>
                                            <li><a href="#">Privacy Policy</a></li>
                                            <li><a href="#">Compliance & Certifications</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom-footer">
                        <strong>Disclaimer:</strong>
                        <p>The air-gapped device and mobile application offered by <strong>Doru.co</strong> are tools designed to enhance the security of digital asset management through offline key generation and transaction signing. While every effort has been made to provide a secure and reliable product, <strong>Doru.co</strong> does not guarantee complete protection against all forms of attack, misuse, or hardware failure.</p>
                        <p>Users are solely responsible for the proper use, storage, and backup of their private keys, seed phrases, and signed transactions. <strong>Doru.co</strong> is not liable for any loss of funds, unauthorized access, or damage resulting from improper use, negligence, or third-party compromise.</p>
                        <p>These products are intended for educational and utility purposes only and do not constitute financial advice, custody services, or a solicitation to buy, hold, or trade any cryptocurrency or token. Users are encouraged to conduct their own due diligence and consult a licensed financial advisor or legal counsel in their jurisdiction before using blockchain or crypto-related technologies. Use of the <strong>Doru.co</strong> device and mobile app signifies your acceptance of these terms.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LandingPage
